import React from "react";
import { Box, Typography } from "@mui/material";
import { COLORS, FONT } from "../shared/styles";

function CheckTickSmall() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="6" viewBox="0 0 9 6" fill="none">
      <path
        d="M8.5 0.5L3.49896 5.5L0.5 2.5"
        stroke="#148DFD"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function WeekendsCheckbox({ checked, onChange, label }) {
  return (
    <Box
      component="label"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: "12px",
        cursor: "pointer",
      }}
    >
      <Box
        component="span"
        role="checkbox"
        aria-checked={checked}
        onClick={(e) => {
          e.preventDefault();
          onChange(!checked);
        }}
        sx={{
          width: 24,
          height: 24,
          borderRadius: "4px",
          border: checked ? `1px solid ${COLORS.primary}` : `1px solid ${COLORS.border}`,
          bgcolor: COLORS.white,
          boxShadow: checked ? "0 1px 2px 0 rgba(20, 141, 253, 0.10)" : "none",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        {checked ? <CheckTickSmall /> : null}
      </Box>
      <Typography
        component="span"
        sx={{
          color: COLORS.textSecondary,
          fontFamily: FONT.family,
          fontSize: "14px",
          fontWeight: 400,
          lineHeight: "18px",
        }}
      >
        {label}
      </Typography>
    </Box>
  );
}

export default WeekendsCheckbox;
